import React from 'react';
import cx from '../../site/utils/cx';
import ui from '../../site/styles/primitives.module.css';
import styles from './PillarGrid.module.css';

// Three text cards with teal / gold / mint top rules, alternating glass and matte surfaces.
const PillarGrid = ({ items }) => (
  <div className={styles.pillars}>
    {items.map((item, index) => (
      <div key={item.title} className={cx(styles.pillar, index % 2 === 0 ? ui.glass : ui.matte)} data-reveal="">
        <h3>{item.title}</h3>
        <p>{item.text}</p>
      </div>
    ))}
  </div>
);

export default PillarGrid;
